var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConcert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53409_338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 22H18.403L14.121 17.879C13.803 17.561 13.415 17.343 13 17.205V6.414L14.591 4.823C14.873 4.934 15.179 5 15.5 5C16.881 5 18 3.881 18 2.5C18 1.119 16.881 0 15.5 0C14.119 0 13 1.119 13 2.5C13 2.822 13.066 3.127 13.177 3.409L8.293 8.293C7.902 8.684 7.902 9.316 8.293 9.707C8.488 9.902 8.744 10 9 10C9.256 10 9.512 9.902 9.707 9.707L11 8.414V17.202C10.588 17.339 10.204 17.554 9.893 17.865L5.597 22H1C0.448 22 0 22.447 0 23C0 23.553 0.448 24 1 24H23C23.553 24 24 23.553 24 23C24 22.447 23.553 22 23 22ZM11.293 19.293C11.67 18.914 12.315 18.9 12.72 19.307L15.518 22H8.48L11.292 19.293H11.293Z",
    fill: "#1D1B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53409_338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcert);
export default __webpack_public_path__ + "static/media/concert.359ef65b107d85527729e755eca377ab.svg";
export { ForwardRef as ReactComponent };